import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

// Images

import SubjectBoxLayers from "../../Assets/Images/LandingPage/subjects_box_vector.svg";

export const SubscriptionPlanCardContainer = styled.div`

    .subscription-card{
            border-radius: 0 50px;
            text-align: center;
            min-height: 380px; 
            height: 100%;
            cursor:pointer;
            padding: 30px;
            position: relative;
            width: 100%;
            height: 100%;
            transition: transform 0.3s ease;
            z-index:1;
            text-align:left;
            &:hover{
                transform: translateY(-8px);
                border-radius: 0 52px;
                box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12); 
            }
            h3{
                color:#000000;
            }
            .sub_text-plan{
                font-size: 24px;
                font-style: normal;
                font-weight: 500;
                margin-bottom: 10px;
            }
            .subscription-card-inner {
                z-index: 1;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
            }
            .subscription-card-bottom{
                padding-top:30px;
            }
            p.redfont{
                font-weight: 500;
            }
            span.price_plans {
                display: block;
                margin-bottom: 20px;
                font-size: 20px;
                font-style: normal;
                font-weight: 300;
            }
            &:after{
                position: absolute;
                content: "";
                background: url(${SubjectBoxLayers}) no-repeat;
                width: 100%;
                height: 100%;
                bottom: 0;
                right: 0;
                background-position: bottom right;
                background-size: 250px;
            }

    }
    @media (max-width: 991px) {
        .subscription-card {
            min-height: 350px;
            height: auto;
        }
    }
    @media (max-width: 767px) {
        .subscription-card {
            min-height: auto;
            height: auto;
        }
        .plans_info_wrapper .subscription-card-col:last-child {
            margin-bottom: 0;
        }
        .plans_section .plans_info_wrapper .subscription-card-col:last-child {
                margin-bottom: 0;
            }
    }
            
`;